import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { postQuantumAPI } from '../services/api';

/**
 * Quantum Security Indicator — ML-KEM / ML-DSA / SLH-DSA readiness chip.
 */
const QuantumSecurityIndicator = () => {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await postQuantumAPI.getHealth();
        if (!cancelled) setStatus(data);
      } catch (e) {
        if (!cancelled) setError(e.message);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (error) {
    return (
      <div className="galaxia-card px-3 py-2 text-xs" style={{ color: 'var(--galaxia-warning)' }}>
        PQ status unavailable
      </div>
    );
  }

  if (!status) {
    return (
      <div className="galaxia-card px-3 py-2 text-xs text-galaxia-muted">
        Checking quantum security…
      </div>
    );
  }

  const color = status.indicator?.color || '#FFD166';
  const label = status.indicator?.label || status.overall;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="galaxia-card px-3 py-2 flex items-center gap-2"
      title="Post-quantum readiness (ML-KEM-1024 · ML-DSA · SLH-DSA)"
    >
      <span
        className="inline-block w-2.5 h-2.5 rounded-full"
        style={{ background: color, boxShadow: `0 0 10px ${color}` }}
      />
      <span className="text-xs font-medium" style={{ color: 'var(--galaxia-text)' }}>
        {label}
      </span>
    </motion.div>
  );
};

export default QuantumSecurityIndicator;
